<script>
    import {Map, TileLayer} from "vpap/svelte/leaflet";
    import MapWrapper from "./MapWrapper.svelte";
    import {tileLayers} from "vpap/svelte/leaflet/defaults";
    import Button from "vpap/svelte/Button.svelte";
    import {currentRound} from "../stores";

    export let containerWidth;
    export let firstRound = true;
    // overall or redistributed
    let section = "overall";

    $: layers = tileLayers.map(d => {
        const opts = Object.assign(
            d.options,
            {minZoom: containerWidth < 500 ? 5 : containerWidth < 700 ? 6 : 7} 
        );
        return Object.assign(d, {options: opts})
    });

    let mapZoom = containerWidth < 500 ? 5 : containerWidth < 700 ? 6 : 7;

    function handleZoom(e) {
        const mapDetail = e.detail.getMap();
        mapZoom = mapDetail.getZoom();
    }
</script>

<div class="map-legend" aria-hidden="true">
    <span class="tie-label"></span> indicates a tie
</div>
{#if !firstRound}
<div class="btn-container">
    <Button fontColor="#607482" isActive={section==="overall"} on:click={() => section = "overall"}>
        Round {$currentRound} Results
    </Button>
    <Button fontColor="#607482" isActive={section === "redistributed"} on:click={() => section = "redistributed"}>
        Votes Redistributed from Round {$currentRound - 1}
    </Button>
</div>
{/if}
<Map
    height={containerWidth/2}
    width={containerWidth}
    id="results-map-leaflet"
    zoom={containerWidth < 500 ? 5 : containerWidth < 700 ? 6 : 7}
    on:zoom={handleZoom}
    description={`A map showing the ${section === "overall" ?  "overall leader in each voting unit" : "candidate who received the most redistributed votes in each voting unit."}`}
>
    {#each layers as layer}
        <TileLayer url={layer.url} options={layer.options}/>
    {/each}
    <MapWrapper {section} {mapZoom}/>
</Map>

<style>

    .btn-container {
        margin-bottom: 15px;
    }

    .map-legend {
        margin-top: .3em;
        margin-bottom: .6em;
    }
    .tie-label {
        background-color: #8b4513;
        width: .9em;
        height: .9em;
        border-radius: 50%;
        display: inline-block;
    }
</style>
